import { darken } from 'polished';
import styled from 'styled-components';

export const SubContainer = styled.section<{ flex?: number }>`
  max-width: 1200px;
  flex: ${({ flex }) => flex || 1};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
  padding: 5px;
  border-radius: ${({ theme }) => theme.metrics.radius};
  background-color: ${({ theme }) => darken(0.05, theme.colors.background)};
  overflow: hidden;

  @media (max-width: ${({ theme }) => theme.metrics.desktop_small}) {
    width: 100%;
    min-width: auto;
    height: max-content;
  }
`;
